<script setup>
import { computed, ref } from 'vue';
import { useUserStore } from '../../../stores/user-store';
import UserBarDropdownItem from './UserBarDropdownItem.vue';
import { useAppStateStore } from '../../../stores/app-state-store';
import DownCaretIcon from '../../icons/DownCaretIcon.vue';
import DownCaretFilledIcon from '../../icons/DownCaretFilledIcon.vue';

const isHovered = ref(false);
const isOpen = ref(false);

const appStateStore = useAppStateStore();
const userStore = useUserStore();

const displayName = computed(
  () => userStore.firstName?.trim() || userStore.name?.trim() || 'GSD Now user'
);
</script>

<template>
  <div class="dropdown">
    <button
      :aria-expanded="isOpen"
      class="dropdown-toggle"
      type="button"
      @click.prevent="isOpen = !isOpen"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      Welcome, {{ displayName }}
      <DownCaretIcon v-if="!isHovered && !isOpen" />
      <DownCaretFilledIcon v-if="isHovered || isOpen" />
    </button>

    <ul :class="['dropdown-menu', { open: isOpen }]">
      <UserBarDropdownItem
        v-if="!userStore.isGuest"
        menu-item-label="Profile &amp; Settings"
        menu-item-location="/profile"
      />

      <UserBarDropdownItem
        menu-item-label="Sign out"
        :menu-item-location="appStateStore.logoutUrl"
      />
    </ul>
  </div>
</template>
